import React from 'react';

import Banner from './Banner';
import ServicesSection from './ServicesSection';
import PricingSection from './PricingSection';
import HowItWorks from './HowItWorks';
import WhyTrustRest from './WhyTrustRest';
import RequestCallback from './RequestCallback';
import FAQSection from './FAQSection';
import ComingSoon from './ComingSoon';
import Footer from './Footer';

const HomePage = () => {
  return (
    <main>
      <section id="banner">
        <Banner />
      </section>
      <section id="services">
        <ServicesSection />
      </section>
      <section id="pricing">
        <PricingSection />
      </section>
      <section id="howitworks">
        <HowItWorks />
      </section>
      <section id="whytrustrest">
        <WhyTrustRest />
      </section>
      <section id="requestcallback">
        <RequestCallback />
      </section>
      <section id="faqsection">
        <FAQSection />
      </section>
      <section id="comingsoon">
        <ComingSoon />
      </section>
      <section id="footer">
        <Footer />
      </section>
    </main>
  );
};

export default HomePage;
